
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/curriculum/hmh",
      function () {
        return require("private-next-pages/curriculum/hmh.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/curriculum/hmh"])
      });
    }
  